import { DefectStatusEnum } from '../../enum/defect-status.enum';
import { MediaData } from './media-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class InspectionDefectData {
  InspectionDefectId: string;
  Comments: string;
  DefectStatus: DefectStatusEnum;
  DefectTypeId: string;
  DefectTypeFurtherInformation: string;
  Media: { [key: string]: MediaData };
}


